import { Controller } from "@hotwired/stimulus"

const CODE_LENGTH = 6

// Login code form: the code field takes digits only, and the form cannot be submitted twice.
export default class extends Controller {
  static targets = ["code", "submit"]

  connect() {
    this.submitting = false
    this.resetBound = this.reset.bind(this)
    window.addEventListener("pageshow", this.resetBound)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.resetBound)
  }

  digitsOnly() {
    this.codeTarget.value = this.digits(this.codeTarget.value)
  }

  // maxlength would cut a pasted "123 456" at the space, so the paste is cleaned first.
  paste(event) {
    event.preventDefault()
    const pasted = (event.clipboardData || window.clipboardData).getData("text")
    this.codeTarget.value = this.digits(pasted)
  }

  submit(event) {
    if (this.submitting) {
      event.preventDefault()
      return
    }
    this.submitting = true
    this.submitTargets.forEach(button => button.classList.add("is-submitting"))
  }

  // The page can come back from the back/forward cache with the form already marked as sent.
  reset() {
    this.submitting = false
    this.submitTargets.forEach(button => button.classList.remove("is-submitting"))
  }

  digits(text) {
    return text.replace(/\D/g, "").slice(0, CODE_LENGTH)
  }
}
